<template>
    <div>
        <b-modal ref="saveModal" :ok-title="$t('misc.create_request')" :cancel-title="$t('misc.cancel')" :title="requestTitle" size="lg" @ok="saveAction">
            <data-table
                :search="false"
                :exportable="false"
                v-if="tableLoaded"
                :rows="getData.rowData"
                :columns="columnData"
                :perPage="perPage"
                :rowsCount="rowsCount"
                :currentPage="currentPage"
                :pageCount="pageCount"
                @rowEnterInput="onInputRow"
                @changePage="changePage"
                @orderByEvent="orderByEvent"
                >
            </data-table>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue';
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import http from '@/libs/http';

import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
import miniToastr from 'mini-toastr';

export default {
    name: 'iso_request_materials',
    components: {
        DataTable,
        notificationIcons
    },
    data() {
        return {
            tableName: 'drawing_part',
            tableNameTranslated: Vue.i18n.translate('general.part.title'),
            tableLoaded: false,
            perPage: 0,
            rowsCount: 0,
            pageCount: 0,
            currentPage: 1,
            sortType: 'asc',
            sortBy: 'id',
            requestTitle: '',
            row: null,
            requests: {},
            getData: {
                rowData: []
            },
            columnData: [
                {
                    label: Vue.i18n.translate('table.request'),
                    field: 'req_qty',
                    numeric: false,
                    html: false,
                    showInput: true,
                },
                {
                    label: Vue.i18n.translate('table.part_number'),
                    field: 'number',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_description'),
                    field: 'description',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_material'),
                    field: 'material',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_size'),
                    field: 'size',
                    numeric: true,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_thk'),
                    field: 'thk',
                    numeric: true,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_sizer'),
                    field: 'sizer',
                    numeric: true,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_thkr'),
                    field: 'thkr',
                    numeric: true,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_dimension'),
                    field: 'dimension',
                    numeric: false,
                    html: false,
                }
            ]
        }
    },
    methods: {
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        changePage (page) {
            this.currentPage = page;
            this.onLoadTable();
        },
        orderByEvent (column, sort_type) {
            this.onLoadTable();
        },
        onLoadTable () {
            let request_ids = '';
            let sep = '';
            Object.keys(this.requests).forEach(key => {
                request_ids += sep + key;
                sep = ',';
            });

            let data = http.route('drawing_part?get_all=1&drawing_id='+this.$route.params.id2+'&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType + '&request_ids='+request_ids).get();
            data.then(response => {
                this.perPage     = response.pagination.limit;
                this.rowsCount   = response.pagination.totalEntries;
                this.currentPage = response.pagination.currentPage;
                this.pageCount   = response.pagination.totalPages;
                var data = response.data;
                this.getData.rowData = [];
                data.forEach(field => {
                    if (typeof (this.requests[field.id]) != 'undefined' && this.requests[field.id] > 0 && this.requests[field.id] != '') {
                        field.req_qty = this.requests[field.id];
                        this.getData.rowData.push(field);
                    }
                });
                this.tableLoaded = true;
            });
        },
        showModal(requests) {
            this.requests = requests;
            this.requestTitle = Vue.i18n.translate('general.part.request_materials');
            this.onLoadTable();
            this.$refs.saveModal.show();
        },
        saveAction(e) {
            e.preventDefault();

            let data = {
                requests: this.requests,
                drawing_id: this.$route.params.id2,
            }

            Object.keys(data).forEach(key => {
                if (data[key] === '') {
                    data[key] = null;
                }
            });

            http.route('drawing_request').post(data, true).then(response => {
                if (response.isError == false) {
                    this.requests = {};

                    this.successMsg(Vue.i18n.translate('general.part.request_created'));
                    this.onLoadTable();
                    this.$refs.saveModal.hide();
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        onInputRow (row, value) {
            this.requests[row.id] = value;
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/project/isometric_management/iso_request_materials.vue